import { render, staticRenderFns } from "./CommonRichTableWithAxios.vue?vue&type=template&id=728347cf&lang=pug&"
import script from "./CommonRichTableWithAxios.vue?vue&type=script&lang=ts&"
export * from "./CommonRichTableWithAxios.vue?vue&type=script&lang=ts&"
import style0 from "./CommonRichTableWithAxios.vue?vue&type=style&index=0&id=728347cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports